/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {AsideMenu} from './AsideMenu'
import {Dropdown2} from '../../../partials'
import portail from '../../../../../package.json'
import {useMetronicAsideHover} from '../../../../components/useMetronicAsideHover'

const AsideDefault: FC = () => {
  const {classes} = useLayout()
  const onHover = useMetronicAsideHover()

  return (
    <div
      id='kt_aside'
      className={clsx('aside overflow-visible bg-primary', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width='{default: "200px", "300px": "250px"}'
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_toggle'
      data-kt-drawer-expand='true'
      data-kt-drawer-expand-on='hover'
    >
      {/* begin::Logo */}
      <div
        className='aside-logo d-none d-lg-flex flex-column align-items-center flex-column-auto py-8'
        id='kt_aside_logo'
      >
        <Link to='/dashboard'>
          <img
            src={toAbsoluteUrl(
              `${onHover ? '/media/icons/menu/logoNBSurplus.svg' : '/media/logos/demo4.svg'}`
            )}
            alt='logo'
            className='h-55px'
          />
        </Link>
      </div>
      {/* end::Logo */}

      {/* begin::Nav */}
      <div
        className='asaside-nav d-flex flex-column align-lg-center flex-column-fluid w-100 pt-5 pt-lg-0'
        id='kt_aside_nav'
      >
        <div
          className='hover-scroll-overlay-y mt-5 mt-lg-0 pb-5 m-3 rounded-1'
          data-kt-scroll='true'
          data-kt-scroll-height='auto'
          data-kt-scroll-offset='10px'
          data-kt-scroll-wrappers='#kt_aside_menu'
          data-kt-scroll-dependencies='#kt_aside_logo, #kt_aside_footer' // faire dépendre la hauteur du menu en fonction du logo et du footer
          data-kt-scroll-activate='{default: false, lg: true}'
        >
          <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
        </div>
      </div>
      {/* end::Nav */}

      {/* begin::Footer */}
      <div
        className='aside-footer d-flex flex-column align-items-center flex-column-auto'
        id='kt_aside_footer'
      >
        <span className='text-white-50 mb-3'>{'V' + portail.version}</span>
      </div>
      {/* end::Footer */}
    </div>
  )
}

export {AsideDefault}
